<template>
  <div class="shareask">
    <Header :white="true" :center="true"/>
    <div class="prompt_wrap">
      <h1>Thanks for adding your name to our campaign.</h1>
      <p>{{ $store.state.firstName }}: we can’t get the changes we need to prevent another Grenfell without growing our campaign.</p>
      <p>
        <strong>Will you share our video with your friends so they can back our campaign too?</strong>
      </p>
      <div class="button_wrap">
        <button
          class="btn primary"
          @click="analytics('Share', 'Share'), gotoSlide(2, 'showShare')"
        >Yes of course</button>
        <button
          class="btn secondary"
          @click="analytics('Skip', 'Share'), gotoSlide(3, 'skipShare')"
        >No sorry</button>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "./Header.vue";

export default {
  name: "ShareAsk",
  props: ["gotoSlide", "analytics"],
  components: {
    Header
  }
};
</script>

<!-- #B3D234 -->
<style scoped lang="scss">
.shareask {
  width: 100%;
  min-height: 100vh;
  background-image: url("../assets/Grenfell1Yr_0004_A.jpg");
  background-size: cover;
  padding-bottom: 20px;
  padding-top: 10px;
  @media only screen and (max-width: 767px) {
    padding: 10px;
  }
  .prompt_wrap {
    width: 100%;
    max-width: 800px;
    background: #fff;
    padding: 60px 40px;
    margin: 0 auto;
    border-radius: 5px;
    margin: 20px auto 0;
    text-align: center;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    @media only screen and (max-width: 767px) {
      padding: 30px 20px 20px;
      margin: 10px auto 0;
    }
    h1 {
      margin: 0 0 10px;
      @media only screen and (max-width: 767px) {
        font-size: 28px;
      }
    }
    p {
      letter-spacing: 0.5px;
      line-height: 1.5;
      font-weight: 500;
      font-size: 18px;
    }
  }
}
</style>
